export default __webpack_public_path__ + "static/media/Abigail 9781843626343.6cfd46b1.jpg";